import { useCallback, useEffect, useRef } from "react";

export function useInfiniteScroll(
  listRef: React.RefObject<HTMLElement>,
  isLoading: boolean,
  threshold: number,
  onLoadMore: () => void
): React.RefObject<HTMLDivElement> {
  const containerRef = useRef<HTMLDivElement>(null);

  const handleScroll = useCallback(() => {
    // @ts-expect-error TS(2531): Object is possibly 'null'.
    const containerBottom = containerRef.current.getBoundingClientRect().bottom;
    if (listRef && listRef.current) {
      const scrollableBottom = listRef.current.getBoundingClientRect().bottom;
      const diff = scrollableBottom - containerBottom;
      const shouldLoad = diff >= 0 && diff <= threshold && !isLoading;

      if (shouldLoad) {
        onLoadMore();
      }
    }
  }, [listRef, threshold, isLoading, onLoadMore]);

  /**
   * Scroll listeners
   */
  useEffect(() => {
    const currentRef = containerRef.current;
    if (currentRef) {
      currentRef.addEventListener("scroll", handleScroll);
    }
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    return () => {
      if (currentRef) {
        currentRef.removeEventListener("scroll", handleScroll);
      }
    };
  }, [handleScroll]);

  return containerRef;
}
